import React from "react";
import  {
  Page,
  Text,
  View,
  Document,
  BlobProvider,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Spin } from "antd";
import { summary_styles as styles, PDFSaved} from './PDF_Helper'


const DisplayContent = props => {
    let i = 0
    return props.data.map(item => {
        let thisStyle = styles.detailContainerGray
        i += 1
        if (i % 2) thisStyle = styles.detailContainer
      return (
        <View key={item.groupKey} style={thisStyle} wrap={false}>
        <Text style={styles.engDetails}>{item.groupKey}</Text>
        <Text style={styles.total}>{item.total.toFixed(2)}</Text>
        </View>
      );
    });
  };

const Heading = props => {
    let OrgName = sessionStorage.getItem("OrganisationName");
    let Address = sessionStorage.getItem("Address");
    return (
      <View key='heading' style={styles.content} wrap={false}>
        <Text style={styles.heading}>{OrgName}</Text>
        <Text style={styles.address}>{Address}</Text>
        <Text style={styles.title}>Contribution Summary</Text>
        <Text style={styles.subTitle}>Period: {props.fromDate.format('DD/MM/YYYY')} to {props.toDate.format('DD/MM/YYYY')}</Text>
        <MemberLine {...props} />
      </View>
    );
  }

  
const TotalLine = props => {
    return (
        <View style={styles.totalContainer} >
            <Text style={styles.engDetails}>Total</Text>
            <Text style={styles.total}>{props.totalAmount.toFixed(2)}</Text>
        </View>
    )
}  

const MemberLine = (props) =>{ 
  //console.log('props.contId:' + props.contId)
  if(props.contId > 0) {
    return <Text style={styles.subTitle}>{`for (${props.offeringNo}) ${props.selectedMember} ` }</Text>
  }
  return null
}


const GetPDF = props => {
    let totalAmount = props.data.reduce( (acc, i) =>  acc + i.total , 0 )
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Heading {...props} />
          <DisplayContent data={props.data} />
          <TotalLine totalAmount={ totalAmount} />
          <Text
            style={styles.footer}
            render={({ pageNumber }) => `Page ${pageNumber}`}
            fixed
          />
        </Page>
      </Document>
    );
  };
  

export default function CreateAndSavePDF(props) {

    if (props.ready) {
      let endDate = props.toDate.format('DD_MM_YYYY')
      //console.log(props.fromDate.format('DD_MM_YYYY'))
      return (
        <BlobProvider document={<GetPDF {...props}  />}>
          {({ blob, url, loading, error }) => {
            //console.log(url);
            if (!loading && url) {
              saveAs(blob, `summary_${endDate}.pdf`); //
              return <PDFSaved doFinish={props.doFinish} />;
            }
            if (loading) {
              return <Spin tip="loading" spinning={true} />;
            }
            if (error) {
              //console.error(error);
              return <p>An error occurred</p>;
            }
  
            return null;
          }}
        </BlobProvider>
      );
    }
    return null;
  }
  
  